const Board = () =>{
  return (
    <div>这是面板页面</div>
  )
}

export default Board